import { postJson } from "../ApiBase";

export const executeStep = (stepId: string) => {
  return postJson(`/v1/execution/step/${stepId}`, {});
};

export const reExecuteStep = (stepId: string) => {
  return postJson(`/v1/execution/step/${stepId}/reexecute`, {});
};
